import React from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { VStack } from '~/components/elements/VStack'
import { useLogEvent } from '~/hooks/useLogEvent'

import { type InputValues } from '../utils'

import styles from './StrategiesInput.css'
import { StrategyInput } from './StrategyInput'

export const StrategiesInput = () => {
  const { t } = useTranslation()
  const { control } = useFormContext<InputValues>()
  const { append, fields, remove } = useFieldArray({
    control,
    keyName: 'fieldId',
    name: 'strategies',
  })

  const logEvent = useLogEvent()
  const handleAddButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    append({
      id: '',
      strategyType: 'new',
      showArrow: true,
      segmentRoutes: [],
      who: '',
      what: '',
      how: '',
    })
    logEvent('Add customer strategy')
  }, [append, logEvent])

  return (
    <VStack spacing={4}>
      {fields.map((field, index) => (
        <StrategyInput key={field.fieldId} index={index} onDelete={remove} />
      ))}

      <StyledButton
        buttonStyle="success"
        className={styles.addButton}
        fillMode="outline"
        icon="add"
        onClick={handleAddButtonClick}
      >
        {t('add_customer_strategy')}
      </StyledButton>
    </VStack>
  )
}
